import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Global } from './../globals';
import utils from './../utils';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root' 
})
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;
    constructor(private router: Router, private globals: Global) {
        // clear alert message on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this.subject.next({});
                }
            }
        });
    }
    clearById(id: string) {
        this.subject.next({ id: id, isClear: true });
    }

    clear() {
        this.subject.next({});
    }

    success(message: string, keepAfterNavigationChange = false, hideAfterInterval: boolean = false, showSpinner: boolean = false, isAppended = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        let messageJson = { id: utils.newGuid(), type: 'success', text: message, showSpinner: showSpinner, isAppended: false };
        this.subject.next(messageJson);
        if (hideAfterInterval) {
            setTimeout(() => {
                this.clearById(messageJson.id);
            }, this.globals.timeoutForAlert);
        }
        return messageJson.id;
    }

    error(message: string, keepAfterNavigationChange = false, hideAfterInterval: boolean = false, showSpinner: boolean = false, isAppended = false) {
        if (message) {
            this.keepAfterNavigationChange = keepAfterNavigationChange;
            let messageJson = { id: utils.newGuid(), type: 'error', text: message, showSpinner: showSpinner, isAppended: false };
            this.subject.next(messageJson);
            if (hideAfterInterval) {
                setTimeout(() => {
                    this.clearById(messageJson.id);
                }, this.globals.timeoutForAlert);
            }
            return messageJson.id;
        }
    }
    warning(message: string, keepAfterNavigationChange = false, hideAfterInterval: boolean = false, showSpinner: boolean = false, isAppended = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        let messageJson = { id: utils.newGuid(), type: 'warning', text: message, showSpinner: showSpinner, isAppended: isAppended };
        this.subject.next(messageJson);

        if (hideAfterInterval) {
            setTimeout(() => {
                this.clearById(messageJson.id);
            }, this.globals.timeoutForAlert);
        }
        return messageJson.id;
    }
    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}